<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    width="7rem"
    (onHide)="close()">
    <n-header>
        <h1>{{i18n.modifyTitle}}</h1>
        <n-help-link key="qoutaModify" *ngIf="!isQuotaReports"></n-help-link>
        <n-help-link key="qoutareportersModify" *ngIf="isQuotaReports"></n-help-link>
    </n-header>

    <n-block [title]="i18n.spaceQuotaLab">
        <form [errorMessage]="errorMessage"
            [formGroup]="vm"
            class="common-form">
            <n-form-item [label]="i18n.hardQuotaLab"
                formGroupName="spaceQuota"
                [helpContent]="i18n.spaceHardQuotaTip">
                <div class="interval-10">
                    <n-capacity id="modify-user-quota-hard-space-quota"
                        [units]="str.capacityUnits"
                        [nonDecimalUnits]="str.capacityUnits"
                        formControlName="hard">
                    </n-capacity>
                    <span>{{str.rangeTip | fn :str.spaceQuotaMin :str.spaceQuotaMax}}</span>
                </div>
            </n-form-item>
            <n-form-item [label]="i18n.softQuotaLab"
                formGroupName="spaceQuota"
                [helpContent]="i18n.spaceSoftQuotaTip">
                <div class="interval-10">
                    <n-capacity id="modify-user-quota-soft-space-quota"
                        [units]="str.capacityUnits"
                        [nonDecimalUnits]="str.capacityUnits"
                        formControlName="soft">
                    </n-capacity>
                    <span>{{str.rangeTip | fn :str.spaceQuotaMin :str.spaceQuotaMax}}</span>
                </div>
            </n-form-item>
        </form>
    </n-block>
    <n-block [title]="i18n.fileQuotaLab">
        <form [errorMessage]="errorMessage"
            [formGroup]="vm"
            class="common-form">
            <n-form-item [label]="i18n.hardQuotaLab"
                formGroupName="fileQuota"
                [helpContent]="i18n.fileHardQuotaTip">
                <div class="interval-10">
                    <n-spinner id="modify-user-quota-hard-file-quota"
                        [min]="str.fileQuotaMin"
                        [max]="vm.get('fileQuota.hardUnit').value | unitTransform :str.fileQuotaMax :'num'"
                        [onlyInput]="true"
                        [required]="false"
                        style="width: 1.8rem;"
                        formControlName="hard">
                    </n-spinner>
                    <n-select style="width:1.1rem"
                        class="ml-10"
                        [options]="str.fileQuotaUnits"
                        formControlName="hardUnit"
                        id="modify-user-quota-hard-file-hardUnit">
                    </n-select>
                    <span>{{str.fileQuotaRange | fn :'1' :i18nService.language === 'zh' ? '20' : '2'}}</span>
                </div>
            </n-form-item>
            <n-form-item [label]="i18n.softQuotaLab"
                formGroupName="fileQuota"
                [helpContent]="i18n.fileSoftQuotaTip">
                <div class="interval-10">
                    <n-spinner id="modify-user-quota-soft-file-quota"
                        [min]="str.fileQuotaMin"
                        [max]="vm.get('fileQuota.softUnit').value | unitTransform :str.fileQuotaMax :'num'"
                        [onlyInput]="true"
                        [required]="false"
                        style="width: 1.8rem;"
                        formControlName="soft">
                    </n-spinner>
                    <n-select style="width:1.1rem"
                        class="ml-10"
                        [options]="str.fileQuotaUnits"
                        formControlName="softUnit"
                        id="modify-user-quota-hard-file-softUnit">
                    </n-select>
                    <span>{{str.fileQuotaRange | fn :'1' :i18nService.language === 'zh' ? '20' : '2'}}</span>
                </div>
            </n-form-item>
        </form>
    </n-block>

    <n-footer>
        <button id="modify-user-quota-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="modify-user-quota-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
